import Vue from "vue"
import VueRouter, { Route, RouteConfig } from "vue-router"
import { AppModule } from "@/store/modules/app"
import i18n from "@/lang"

Vue.use(VueRouter)

export const baseRoutes: RouteConfig[] =
	[
		{
			path: "/" + i18n.t("routes.frontpage.path"),
			name: "Frontpage",
			component: () => import(/* webpackChunkName: "frontpage" */ "@/views/frontpage/Frontpage.vue")
		},
		{
			path: "/" + i18n.t("routes.about.path"),
			name: "About",
			component: () => import(/* webpackChunkName: "about" */ "@/views/about/About.vue")
		},
		{
			path: "/" + i18n.t("routes.parents.path").toString(),
			name: "AboutParents",
			component: () => import(/* webpackChunkName: "aboutparents" */ "@/views/about/Parents.vue")
		},
		{
			path: "/" + i18n.t("routes.institutions.path").toString(),
			name: "AboutInstitutions",
			component: () => import(/* webpackChunkName: "aboutinstitutions" */ "@/views/about/Institutions.vue")
		},
		{
			path: "/" + i18n.t("routes.features.path"),
			name: "Features",
			component: () => import(/* webpackChunkName: "features" */ "@/views/features/Features.vue")
		},
		{
			path: "/" + i18n.t("routes.prices.path"),
			name: "Prices",
			component: () => import(/* webpackChunkName: "prices" */ "@/views/prices/Prices.vue")
		},
		{
			path: "/" + i18n.t("routes.terms.path"),
			name: "Terms",
			component: () => import(/* webpackChunkName: "terms" */ "@/views/terms/Terms.vue")
		},
		{
			path: "/" + i18n.t("routes.privacypolicy.path"),
			name: "Privacypolicy",
			component: () => import(/* webpackChunkName: "privacypolicy" */ "@/views/terms/Privacypolicy.vue")
		},
		{
			path: "/" + i18n.t("routes.cookies.path"),
			name: "Cookies",
			component: () => import(/* webpackChunkName: "cookies" */ "@/views/terms/Cookies.vue")
		},
		{
			path: "/" + i18n.t("routes.datasafety.path"),
			name: "Datasafety",
			component: () => import(/* webpackChunkName: "datasafety" */ "@/views/terms/Datasafety.vue")
		},
		{
			path: "/" + i18n.t("routes.contact.path"),
			name: "Contact",
			component: () => import(/* webpackChunkName: "contact" */ "@/views/support/Contact.vue")
		}
	]

export const asyncRoutes: RouteConfig[] = []

const createRouter = () => new VueRouter({
	mode: "history",
	scrollBehavior: (to, from, savedPosition) =>
	{
		if (savedPosition)
		{
			return savedPosition
		}
		else
		{
			return { x: 0, y: 0 }
		}
	},
	base: process.env.BASE_URL,
	routes: baseRoutes
})

const router = createRouter()

router.afterEach((to: Route) =>
{
	AppModule.HideHeaderMenu()
})

export function resetRouter()
{
	const newRouter = createRouter();
	(router as any).matcher = (newRouter as any).matcher
}

export default router
